import React, { useRef, useState } from 'react';
import { View } from 'react-native';
import MyAppText from './MyAppText';
import { TextInputMask, TextInputMaskMethods } from 'react-native-masked-text';
import { translate } from '../services/translate';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface MyDateTimeInputProps {
    label: string;
    date: string;
    onChangeDate: (value: string) => void;
    time: string;
    onChangeTime: (value: string) => void;
    editable?: boolean;
}

type InputMask = TextInputMask & TextInputMaskMethods;

export default function MyDatetimeInput({ label, date, time, onChangeDate, onChangeTime, editable = true }: MyDateTimeInputProps) {
    const { styles, theme } = useStyles(styleSheet);
    const [isInvalid, setIsInvalid] = useState(false);
    const dateInputRef = useRef<InputMask>(null);
    const hourInputRef = useRef<InputMask>(null);

    return (
        <View style={{ rowGap: 5 }}>
            <MyAppText style={styles.label}>{label}</MyAppText>
            <View style={{ flexDirection: 'row', columnGap: 5 }}>
                <TextInputMask
                    value={date}
                    onChangeText={(text: string) => {
                        onChangeDate(text);
                    }}
                    keyboardType={'numeric'}
                    type={'datetime'}
                    style={[styles.input, { maxWidth: 115 }, {
                        color: date == '' ? theme.colors.placeholder : theme.colors.textColor,
                    }, !editable ? styles.disabled : undefined, isInvalid ? styles.invalid : undefined]}
                    options={{
                        format: 'DD/MM/YYYY'
                    }}
                    onBlur={() => {
                        setIsInvalid(!dateInputRef.current?.isValid() || false);
                    }}
                    ref={dateInputRef}
                    editable={editable}
                />
                <TextInputMask
                    value={time}
                    onChangeText={onChangeTime}
                    keyboardType={'numeric'}
                    type={'datetime'}
                    style={[styles.input, { maxWidth: 90 }, {
                        color: time == '' ? theme.colors.placeholder : theme.colors.textColor,
                    }, !editable ? styles.disabled : undefined, isInvalid ? styles.invalid : undefined]}
                    options={{
                        format: 'HH:mm:ss'
                    }}
                    onBlur={() => {
                        setIsInvalid(!hourInputRef.current?.isValid() || false);
                    }}
                    ref={hourInputRef}
                    editable={editable}
                />
            </View>
            {isInvalid ?
                <MyAppText style={styles.error}>{translate('invalidDateTime')}</MyAppText> : null}
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    label: {
        color: theme.colors.labelColor,
    },
    input: {
        fontSize: 16,
        fontFamily: 'Open Sans',
        backgroundColor: theme.colors.field.background,
        borderColor: theme.colors.field.border,
        borderWidth: 1,
        maxHeight: 40,
        padding: 10,
        borderRadius: 4,
        color: theme.colors.textColor,
    },
    error: {
        color: '#FF0000',
        fontSize: 10
    },
    invalid: {
        borderColor: '#FF0000',
    },
    disabled: {
        backgroundColor: theme.colors.field.disabledBackground
    }
}));
